import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { RentalObjectCategory } from '../../model/const/enums';
import { CreateContractCommandHandler } from '../../service/command/create-contract-command-handler.service';
import { VacantCommandHandlerResolver } from '../../service/command/vacant-command-handler-resolver.service';
import { ColumnDefinitionService } from '../../service/data/column-definition.service';
import { VacantRentalObjectService } from '../../service/data/vacant-period.service';
import { VacantRentalObjectComponentBase } from '../base/vacant-rental-object.base';

@Component({
    selector: 'app-vacant-other-rental-object',
    templateUrl: './vacant-other-rental-object.component.html',
    styleUrls: ['./vacant-other-rental-object.component.scss'],
    providers: [CreateContractCommandHandler, VacantCommandHandlerResolver, { provide: 'category', useValue: RentalObjectCategory.Other }],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VacantOtherRentalObjectComponent extends VacantRentalObjectComponentBase {
  constructor(
    columnDefinitionService: ColumnDefinitionService,
    messageService: MessageService,
    navigation: NavigationService,
    service: VacantRentalObjectService,
    dispatcher: CommandDispatcher,
    handlerResolver: VacantCommandHandlerResolver
  ) {
    super(columnDefinitionService, messageService, navigation, service, dispatcher, handlerResolver);
  }

  protected get category(): RentalObjectCategory {
    return RentalObjectCategory.Other;
  }

  onRowClicked(e: { context: any; event: any }): void {
    this.navigation.navigate(['vacantother-rental-object', 'edit', e.context.rentalObjectId], null, e.event.ctrlKey);
  }
}
